import { render, staticRenderFns } from "./CompleteKeyboard.vue?vue&type=template&id=39e3a881&scoped=true"
import script from "./CompleteKeyboard.vue?vue&type=script&lang=js"
export * from "./CompleteKeyboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e3a881",
  null
  
)

export default component.exports